var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"btn btn-outline-secondary btn-sm ml-3",on:{"click":_vm.reActivateUser}},[_vm._v("Reactivate")])])}
var staticRenderFns = []

export { render, staticRenderFns }